import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_exploration'

export default function DreamExplorationPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Why do you want to explore your dreams?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamExploration.heading')}
      buttons={[
        {
          text: `🪞 ${t('pages.onboarding.dreamExploration.options.understandMyself')}`,
          value: 'Understand myself better',
        },
        {
          text: `🧠 ${t('pages.onboarding.dreamExploration.options.curiousAboutAI')}`,
          value: 'Curious what AI sees in them',
        },
        {
          text: `🌱 ${t('pages.onboarding.dreamExploration.options.selfAwarenessJourney')}`,
          value: 'I’m on a self-awareness journey',
        },
        {
          text: `😴 ${t('pages.onboarding.dreamExploration.options.loveWeirdDreams')}`,
          value: 'I just love weird dream stuff',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      withLogin={window.ReactNativeWebView ? false : true}
    />
  )
}
